import React from 'react'

const DriversOnPolicy = ({ context, changeClass, method }) => {
  var storedDrivers = changeClass?.driversHHMs?.drivers?.storedDrivers

  return (
    <>
      <h5 className='text-primary text-center fw-bold my-3'>DRIVERS ON POLICY</h5>

      <p className="text-center fw-bold">
        Your policy has the below driver(s) currently listed as operating the policy vehicle(s):
      </p>

      <div className="row justify-content-center mb-3">
        <div className="col-xl-8 col-lg-8 col-md-8">
          {/* Stored Drivers */}
          {storedDrivers.map((driver, index) => {
            return (
              <div key={index}>
                {/* Driver details in grid columns */}
                <div className="row mb-2 align-items-center">
                  <div className="col-4">
                    <span className="fw-bold">{driver.fullName}</span>
                  </div>
                  <div className="col-4">
                    <span className='col-4'> DOB ({driver.DOB})</span>
                  </div>

                  {/* Do not display Update button for insured driver */}
                  {index != 0 &&
                    <div className="col-4 text-end">
                      <button type="button" className={`btn btn-default pull-right text-primary editCancelBtn`} value={"UpdateDriver"} style={{ width: "75%" }}
                        onClick={(e) => method(e.target.value, index)}
                      >
                        Update
                      </button>
                    </div>
                  }
                </div>
                <hr className="less-margin" />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default DriversOnPolicy